var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitclub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -988.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.061 988.36c-5.0697 0-9.1833 6.2051-9.1833 13.853 0 6.5152 8.3509 17.477 8.0266 22.682-2.6814 1.4876-10.966-12.24-15.247-12.24-5.0697 0-9.1833 6.2051-9.1833 13.853 0 7.6474 4.1135 13.852 9.1833 13.852 4.3969 0 11.932-13.716 15.247-12.478l-5.5689 24.477 13.354-.08s-5.8504-23.731-5.8576-24.292h.10514v.027c3.2462-1.2163 11.039 12.61 15.405 12.61 5.0697 0 9.1833-6.2051 9.1833-13.853 0-7.6474-4.1135-13.853-9.1833-13.853-4.264 0-11.993 13.501-15.387 12.108.04769-5.334 8.2895-16.306 8.2895-22.814 0-7.6476-4.1135-13.853-9.1833-13.853z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitclub);
export default __webpack_public_path__ + "static/media/suitclub.09dc2f320c1f7d780df9deee16754de5.svg";
export { ForwardRef as ReactComponent };